import { Injectable } from "@angular/core";
import { Inspection } from "../types/Inspection/Inspection";
import { ClientService } from "../services/client.service";
import { BaseClientRepository } from "./abstract/base.client.repository";

@Injectable({
  providedIn: "root",
})
export class SelectedInspectionRepository extends BaseClientRepository<Inspection> {
  constructor(clientService: ClientService) {
    super(clientService, "selectedInspection");
  }
}
